import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { ref: "onBoardingPrintRef" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "btn-icon",
  width: "100%",
  height: "100%",
  viewBox: "0 0 33 33",
  version: "1.1",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(2.0625,0,0,2.0625,-3118.5,-3446.44)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M1521.6,1683L1521.6,1683.8L1518.4,1683.8L1518.4,1683L1521.6,1683ZM1522.66,1677.4L1524.8,1677.4L1524.8,1678.46L1522.66,1678.46L1522.66,1677.4ZM1524.8,1674.2L1524.8,1671L1515.2,1671L1515.2,1674.2L1514.89,1674.26C1514.12,1674.26 1513.38,1674.57 1512.84,1675.12C1512.3,1675.68 1512,1676.42 1512,1677.2L1512,1681.45C1512,1683.06 1513.33,1684.38 1514.94,1684.39L1515.2,1684.86L1515.2,1687L1524.8,1687L1524.8,1684.86L1525.06,1684.39C1526.67,1684.38 1528,1683.06 1528,1681.45L1528,1677.2C1527.99,1675.59 1526.67,1674.27 1525.06,1674.26L1524.8,1674.2ZM1522.4,1674.2L1517.6,1674.2L1517.6,1672.6L1522.4,1672.6L1522.4,1674.2ZM1522.4,1685.4L1522.4,1682.2L1517.6,1682.2L1517.6,1685.4L1522.4,1685.4ZM1526.22,1682.6C1526.52,1682.3 1526.4,1681.05 1526.4,1680.6L1526.4,1677.4C1526.5,1676.94 1526.43,1676.47 1526.22,1676.06C1525.79,1675.81 1525.29,1675.72 1524.8,1675.8L1515.2,1675.8C1514.71,1675.72 1514.21,1675.81 1513.77,1676.04C1513.48,1676.34 1513.49,1682.3 1513.78,1682.6C1514.09,1682.91 1514.5,1683.08 1514.94,1683.08L1515.2,1682.74L1515.2,1680.6L1524.8,1680.6L1524.8,1682.74L1525.06,1683.08C1525.49,1683.08 1525.9,1682.91 1526.2,1682.62L1526.22,1682.6Z" })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Print", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrintOptions = _resolveComponent("PrintOptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isPrintedSheetLabel)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleShowPrintOptions && _ctx.handleShowPrintOptions(...args))),
          "aria-label": "Open print preview drop down",
          ref: "printBtn",
          class: "btn print"
        }, _hoisted_4, 512))
      : _createCommentVNode("", true),
    (_ctx.showPrintOptions)
      ? (_openBlock(), _createBlock(_component_PrintOptions, {
          key: 1,
          onSetPrintOptionsPosition: _ctx.setPrintOptionsPosition,
          onSaveAndContinue: _ctx.saveAndContinue
        }, null, 8, ["onSetPrintOptionsPosition", "onSaveAndContinue"]))
      : _createCommentVNode("", true)
  ], 512))
}